import {inject, Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {CoreConfig} from '../core.config';
import {map} from "rxjs/operators";
import {
  DominoArrayResponse,
  DominoAttachmentListItem, DominoFavorite,
  DominoResponse, DominoSubscriptionAttachment, DominoSubscriptionCollection,
  DominoSubscriptionDocument, DominoSubscriptionPublisher
} from "../models/domino-response.model";
import {Attachment} from "../models/attachment.model";
import {Observable} from "rxjs";
import {
  Favorite,
  SubscriptionAttachment,
  SubscriptionCollection,
  SubscriptionDocument,
  SubscriptionPublisher
} from "../models/document.model";

@Injectable({
  providedIn: 'root'
})
export class FavoriteResource {
  public httpClient = inject(HttpClient);
  public coreConfig = inject(CoreConfig);


  getFavorites(): Observable<Favorite[]> {
    return this.httpClient.get<DominoResponse<DominoFavorite[]>>(`${this.coreConfig.api.baseUrl}/${this.coreConfig.dominoConfig.favoriteDatabase}/GetUserFavorites?OpenAgent`, {
      withCredentials: true
    }).pipe(
      map(response => response.data),
      map(favorites => favorites.map(favorite => {
        const length = favorite.publisherid?.length ?? 0;
        const level = length === 4 ? 1 : length === 6 ? 2 : length === 8 ? 3 : 0;
        return {
          id: favorite.id,
          title: favorite.title,
          level: level,
          doctype: favorite.doctype,
          publisher: favorite.publisher,
          publisherId: favorite.publisherid,
          createdAt: favorite.created.substring(0,10),
          type: favorite.plejelaegelig ?? null,
          dbFilePath: favorite.dbfilepath,
          dbFilePathShort: favorite.dbfilepath ? favorite.dbfilepath.match(/\/([^\/]+)\.nsf$/)?.[1] : '',
          tagIds: favorite.tags ?? [],
        } as Favorite;
      })),
    )
  }
  endpoint(id: string, type: "document"|"collection", action: "create"|"remove") {
    return this.httpClient.get<DominoResponse<DominoFavorite>>(`${this.coreConfig.api.baseUrl}/${this.coreConfig.dominoConfig.favoriteDatabase}/updateUserFavorites?OpenAgent&doctype=${type}&action=${action}&id=${id}`, {
      withCredentials: true
    }).pipe(
      map(response => {
        if ( ! response.success) {
          throw new Error('API Error: ' + (response as any)?.msg);
        }
        return response.success;
      }),
    )
  }

  setTags(id: string, type: "document"|"collection", tags: string[]) {
    const tagString = [...new Set(tags)].join('¤');
    return this.httpClient.get<DominoResponse<any>>(`${this.coreConfig.api.baseUrl}/${this.coreConfig.dominoConfig.favoriteDatabase}/updateUserFavorites?OpenAgent&doctype=${type}&action=update&id=${id}&tags=${tagString}`, {
      withCredentials: true
    }).pipe(
      map(response => {
        if ( ! response.success) {
          throw new Error('API Error: ' + (response as any)?.msg);
        }
        return response.success;
      }),
    )
  }

  createTag(name: string, color: string) {
    name = encodeURIComponent(name);
    color = encodeURIComponent(color);
    return this.httpClient.get<{success: boolean; id: string}>(`${this.coreConfig.api.baseUrl}/${this.coreConfig.dominoConfig.favoriteDatabase}/updateUserTags?OpenAgent&action=create&name=${name}&color=${color}`, {
      withCredentials: true
    }).pipe(
      map(response => {
        if ( ! response.id) {
          throw new Error('API Error: ' + (response as any)?.msg);
        }
        return response.id;
      }),
    );
  }

  updateTag(id: string, name: string, color: string) {
    name = encodeURIComponent(name);
    color = encodeURIComponent(color);
    return this.httpClient.get<DominoResponse<any>>(`${this.coreConfig.api.baseUrl}/${this.coreConfig.dominoConfig.favoriteDatabase}/updateUserTags?OpenAgent&action=update&id=${id}&name=${name}&color=${color}`, {
      withCredentials: true
    }).pipe(
      map(response => {
        if ( ! response.success) {
          throw new Error('API Error: ' + (response as any)?.msg);
        }
        return response.success;
      }),
    );
  }

  deleteTag(id: string) {
    return this.httpClient.get<DominoResponse<any>>(`${this.coreConfig.api.baseUrl}/${this.coreConfig.dominoConfig.favoriteDatabase}/updateUserTags?OpenAgent&action=remove&id=${id}`, {
      withCredentials: true
    }).pipe(
      map(response => {
        if ( ! response.success) {
          throw new Error('API Error: ' + (response as any)?.msg);
        }
        return response.success;
      }),
    );
  }
}
